import React from 'react'
import ResultMainSeriesItem from './ResultMainSeriesItem'

const ResultMainSeries = ({ goodData }) => {
  return (
    <div className='packResultBlock'>
        <p className='packResultBlock__text'>
            Перевірте, чи вірно отримано основний товар з коробки? Якщо так, то додайте новий товар
        </p>
        <div className='packResultBlock__list'>
            <ResultMainSeriesItem
                text='Тип товару'
                value={
                    goodData && goodData.goodType ? goodData.goodType.name : ''
                }
            />
            <ResultMainSeriesItem
                text='Назва товару'
                value={
                    goodData && goodData.good ? goodData.good.name : ''
                }
            />
        </div>
    </div>
  )
}

export default ResultMainSeries